import { baseService } from './baseService'
import { useQuery } from '@tanstack/react-query'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../utils/showToast'
import { useParseQuery } from '../hooks/useNav'
import { bookBorrowKeys } from '../data/queryFactories'
import { accountsBorrowKeys } from '../data/queryFactories'
import { convertUnixToDate } from '../utils/conversion'
/** Service: chỉ lo gọi API */
class BookBorrowService extends baseService {
  async getAllBookBorrow(paramsData) {
    try {
      const res = await this.get('borrow/books', paramsData)
      if (res && res.status === 200) {
        return res.data
      } else {
        throw new Error('Lỗi khi lấy dữ liệu')
      }
    } catch (error) {
      throw error
    }
  }
  async getAllUsersBorrowingBook(uuid, paramsData) {
    try {
      const res = await this.get(`borrow/borrow-users/${uuid}`, paramsData)
      if (res?.data?.meta.code === 200) {
        return res.data
      } else {
        throw new Error('Lỗi khi lấy dữ liệu')
      }
    } catch (error) {
      throw error
    }
  }
}

export const bookBorrowService = new BookBorrowService()
export const formatSeconds = (seconds) => {
  if (!Number.isInteger(seconds) || seconds < 0) {
    throw new Error('Tham số phải là số nguyên không âm')
  }

  // Nếu chia hết cho 3600 thì chỉ hiển thị giờ
  if (seconds % 3600 === 0) {
    return `${seconds / 3600} giờ`
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  let parts = []
  if (hours > 0) parts.push(`${hours} giờ`)
  if (minutes > 0) parts.push(`${minutes} phút`)
  if (secs > 0) parts.push(`${secs} giây`)

  return parts.join(' ')
}
export function useGetBooksBorow() {
  // const formatSeconds = (seconds) => {
  //   if (!Number.isInteger(seconds) || seconds < 0) {
  //     throw new Error('Tham số phải là số nguyên không âm')
  //   }

  //   // Nếu chia hết cho 3600 thì chỉ hiển thị giờ
  //   if (seconds % 3600 === 0) {
  //     return `${seconds / 3600} giờ`
  //   }

  //   const hours = Math.floor(seconds / 3600)
  //   const minutes = Math.floor((seconds % 3600) / 60)
  //   const secs = seconds % 60

  //   let parts = []
  //   if (hours > 0) parts.push(`${hours} giờ`)
  //   if (minutes > 0) parts.push(`${minutes} phút`)
  //   if (secs > 0) parts.push(`${secs} giây`)

  //   return parts.join(' ')
  // }
  const { queryParams } = useParseQuery()
  return useQuery({
    queryKey: bookBorrowKeys.list(queryParams),
    queryFn: async () => {
      try {
        showLoadingToast('Đang tải', toastKey.BOOKS_MANAGEMENT.BORROW.LIST.GET)

        const pageNumber = (parseInt(queryParams?.pageNumber, 10) || 1) - 1
        const pageSize = 10
        const data = await bookBorrowService.getAllBookBorrow({
          ...queryParams,
          pageNumber,
          pageSize,
        })
        const convertDataBook =
          data?.data?.pageItems?.map((item) => ({
            titleBorrow: item.book.title,
            author: item.book.author,
            borrowCount: item.borrowCount,
            timeOfBorrow: formatSeconds(item.timeOfBorrow),
            getInforFromUUID: item.book.uuid,
          })) ?? []

        if (data?.meta?.message !== 'success')
          throw new Error(data?.meta?.message || 'API trả về lỗi')
        if (!data?.meta?.message) throw new Error('Không có dữ liệu trả về!')

        showSuccessToast(
          'Tải sách thành công',
          toastKey.BOOKS_MANAGEMENT.BORROW.LIST.GET
        )

        return {
          totalResult: data?.data?.totalResult,
          totalPages: data?.data?.totalPages,
          currentPage: data?.data?.currentPage,
          books: convertDataBook ?? [],
        }
      } catch (error) {
        showErrorToast({
          error: error.message,
          message: 'Lấy thông tin thất bại',
          toastId: toastKey.BOOKS_MANAGEMENT.LIST.GET,
        })
        throw error
      }
    },
  })
}
export function useGetAccountsListPerBorrowBook(uuid) {
  const { queryParams } = useParseQuery()
  return useQuery({
    queryKey: accountsBorrowKeys.list({ ...queryParams, uuid }),
    queryFn: async () => {
      try {
        showLoadingToast(
          'Đang tải',
          toastKey.BOOKS_MANAGEMENT.BORROW.LIST.DETAIL
        )
        const pageNumber = (parseInt(queryParams?.pageNumber, 10) || 1) - 1
        const pageSize = 10
        const data = await bookBorrowService.getAllUsersBorrowingBook(uuid, {
          ...queryParams,
          pageNumber,
          pageSize,
        })
        const convertDataAccounts =
          data?.data?.pageItems?.map((item) => ({
            Accounts: item.user.schoolId,
            fullName: item.user.fullName,
            borrowDate: convertUnixToDate(item.borrowStart),
            returnDate: convertUnixToDate(item.borrowEnd),
            idAccount: item.user.uuid,
          })) ?? []

        if (data?.meta?.message !== 'success')
          throw new Error(data?.meta?.message || 'API trả về lỗi')
        if (!data?.meta?.message) throw new Error('Không có dữ liệu trả về!')

        showSuccessToast(
          'Tải danh sách người mượn thành công',
          toastKey.BOOKS_MANAGEMENT.BORROW.LIST.DETAIL
        )
        return {
          totalResult: data?.data?.totalResult,
          totalPages: data?.data?.totalPages,
          currentPage: data?.data?.currentPage,
          accounts: convertDataAccounts ?? [],
        }
      } catch (error) {
        showErrorToast({
          error: error.message,
          message: 'Lấy thông tin thất bại',
          toastId: toastKey.BOOKS_MANAGEMENT.BORROW.LIST.DETAIL,
        })
        throw error
      }
    },
  })
}
